import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Forbidden() {
  return (
    <div className="py-24 sm:py-32 flex items-center justify-center">
      <SEO preset="forbidden" />
      <div className="max-w-xl mx-auto px-4 text-center space-y-6">
        <span className="font-sans text-6xl sm:text-7xl font-bold text-espresso/30 block tracking-widest">
          403
        </span>

        <h1 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
          Adgang nægtet
        </h1>

        <p className="text-taupe text-base sm:text-lg leading-relaxed">
          Du har desværre ikke adgangstilladelse til denne ressource. Vend venligst tilbage til forsiden.
        </p>

        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-accent-brown text-white text-xs font-semibold uppercase tracking-widest hover:bg-accent-brown-hover transition-colors shadow-xs"
          >
            <i className="fa-solid fa-arrow-left text-xs" aria-hidden="true" />
            <span>Tilbage til forsiden</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
